import AnchoredPopover from "app/components/shared/Popover/anchored";
import Emojify from "app/components/shared/Emojify";
import FriendlyTime from "app/components/shared/FriendlyTime";
import { capitalize } from "lodash";
import Icon from "app/components/shared/Icon";
import Bar, { ActivityProps, StyledAnchoredPopover } from "../../shared/Activity/Bar";

type StackedBarsProps = {
  activities: Array<ActivityProps>;
  height: number;
};

const StackedBars = ({ activities, height }: StackedBarsProps) => {
  const totalDuration = activities.reduce((sum, activity) => sum + activity.duration, 0);

  const bars = (
    <>
      {activities.map((activity) => (
        <Bar key={activity.id} activity={activity} height={activity.duration / totalDuration} />
      ))}
    </>
  );

  return (
    <div
      className="flex flex-col items-start"
      style={{ height: `${Math.round(height * 100.0)}%`, width: 12 }}
    >
      <StyledAnchoredPopover as={AnchoredPopover} data-testid="bar" width={300}>
        {bars}
        <div className="flex flex-col gap-1 px-2 py-1">
          <span className="block font-medium break-words">
            <Emojify text={activities[0].name} />
          </span>

          {activities[0].buildNumber && (
            <div className="dark-gray small">Build #{activities[0].buildNumber}</div>
          )}

          {activities[0].branch && (
            <div className="dark-gray small">
              <Icon icon="custom/outline/14x/branch" style={{ height: 14, width: 14 }} />{" "}
              {activities[0].branch}
            </div>
          )}

          <span className="block small dark-gray">
            <strong>Execution summary</strong>
            <br />
            {activities.map((activity) => (
              <span className="block" key={activity.id}>
                {capitalize(activity.result)}{" "}
                <FriendlyTime value={activities[0].createdAt} clickable={false} /> -{" "}
                {activity.humanDuration}
              </span>
            ))}
          </span>
        </div>
      </StyledAnchoredPopover>
    </div>
  );
};

export default StackedBars;
